module.exports = __webpack_public_path__ + "img/79497721.77ef4fb1.jpg";